import React, { useCallback, useContext, useState } from 'react';
import styled from 'styled-components';
import ExperimentProviderContext from '~/library/helpers/src/experiment/experiment/provider';

const Tab = styled.div`
  border: 5px solid pink;
  display: inline-block;
  padding: 0 15px 5px;
  border-radius: 20px 0 0 2px;
  border-style: solid;
  border-width: 1px 0 0 1px;
  cursor: help;
  z-index: 1000000000000;
  background-color: rgb(255 255 255 / 60%);
  text-align: left;
  max-height: 100%;
  overflow: auto;
  position: relative;
`;

const ExperimentGroup = styled.div`
  border-bottom: solid 1px black;
  padding-top: 15px;
`;

const RadioWidthOverride = styled.input`
  width: 1em;
  clip: inherit;
  height: 1em;
  position: inherit;
`;

const CenteredParagraph = styled.p`
  text-align: center;
  margin: 0 15px 5px;
`;

const ExperimentBucketing = () => {
  const { UpdateAssignedBucketByExperimentName, experiments } = useContext(
    ExperimentProviderContext
  );
  const [showExperiments, setShowExperiments] = useState(false);

  const showHideExperiments = useCallback(() => {
    setShowExperiments(currentShowExperiments => !currentShowExperiments);
  }, [setShowExperiments]);

  const updateBucket = useCallback(
    (experimentName: string, bucketName: string) => {
      UpdateAssignedBucketByExperimentName({ bucketName, experimentName });
    },
    [UpdateAssignedBucketByExperimentName]
  );

  const isProduction = process.env.NODE_ENV === 'production';
  const hasExperiments = Object.keys(experiments).length > 0;

  if (isProduction || !hasExperiments) return null;

  return (
    <Tab>
      <CenteredParagraph
        onClick={showHideExperiments}
        data-analytics-id="pp_devpanel_experiments_header"
      >
        Experiments
      </CenteredParagraph>
      {showExperiments && (
        <>
          {Object.keys(experiments).map(experimentName => (
            <ExperimentGroup key={experimentName}>
              <b>{experimentName}</b>
              {(experiments[experimentName].buckets || [])
                .sort()
                .map(bucket => {
                  const id = `${experimentName}-${bucket}`;
                  return (
                    <div key={id}>
                      <label htmlFor={id}>
                        <RadioWidthOverride
                          type="radio"
                          name={id}
                          id={id}
                          value={bucket}
                          onChange={() => updateBucket(experimentName, bucket)}
                          checked={
                            bucket ===
                            experiments[experimentName].assignedBucket
                          }
                        />
                        {bucket}
                      </label>
                    </div>
                  );
                })}
            </ExperimentGroup>
          ))}
        </>
      )}
    </Tab>
  );
};

export default ExperimentBucketing;
